import React, { Suspense, useEffect, useState } from 'react';
import Header from '../Header/header';
import { CommonUtilities } from '../../commonUtils';
import cachingMechanisum from '../Common/cachingMechanisum';

const Dashboard = React.lazy(() => import("./dashboard"));
const Statements = React.lazy(() => import("./Statements"));
const ProjectContracts = React.lazy(() => import("../Dashboard/projectContracts"));


export default function IndexDashboard(autoOpen: any) {

    const [flag, setFlag] = useState(true);
    const [flagList, setFlagList] = useState(true);
    const [showTab, setShowTab] = useState(0);
    const [pageNumber, setPageNumber] = useState("");
    var userID = CommonUtilities.getAuthAccess().email;
    var [selectedMonth, setSelectedMonth] = React.useState('2010-01-31T00:00:00');
    let [periodSelected, SetperiodSelected] = useState<any>([]);

    useEffect(() => {

        var periodListCache = cachingMechanisum.getCachingStorage("SystemPeriod");
        //console.log(periodListCache)
        for (var i = 0; i < periodListCache?.length; i++) {
            if (periodListCache[i].periodCurrent === 1) {
                periodSelected = periodListCache[i]
                SetperiodSelected(periodSelected)

                setFlagList(false);
                setSelectedMonth(periodListCache[i].periodTo);
            }
        }

    }, []);

    return (
        <div className={"landingPage ws-12 box"}>

            <div className='ws-12 bgWhite'>
                <Header Title={"Dashboard"} />
            </div>

            <div className={showTab === 0 ? "ws-12 landing" : "hide landingPage"}>
                <div className="ws-4">
                    <Suspense fallback={<div>Loading</div>}>
                        <Statements></Statements>
                    </Suspense>
                </div>

                <div className="ws-4">
                    <Suspense fallback={<div>Loading</div>}>
                        <Dashboard />
                    </Suspense>
                </div>

                <div className="ws-4">
                    <Suspense fallback={<div>Loading</div>}>
                        <ProjectContracts />
                    </Suspense>
                </div>
            </div>



        </div>
    )
}